import { Disclosure } from "@headlessui/react";
import { ChevronDown } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export default function FAQ() {
  const faqs = [
    {
      question: "KolayYük nedir?",
      answer:
        "KolayYük, yük verenlerle nakliyecileri bir araya getiren dijital bir teklif platformudur. Yük verenler ilan oluşturur, nakliyeciler teklif gönderir ve taraflar anında iletişime geçebilir.",
    },
    {
      question: "Yük veren olarak nasıl ilan oluşturabilirim?",
      answer:
        "Uygulamayı indirip kayıt olduktan sonra yükün kalkış–varış konumunu, malzeme türünü ve ağırlığını girerek ilan oluşturabilirsiniz. Nakliyeciler tekliflerini göndermeye başlar.",
    },
    {
      question: "Nakliyeci olarak nasıl teklif verebilirim?",
      answer:
        "Profilinizi oluşturduktan sonra rotanıza uygun yükleri görüntüleyebilir, detayları inceleyebilir ve kendi fiyat teklifinizi yük verene iletebilirsiniz. Yük veren teklifi kabul ederse iletişime geçersiniz.",
    },
    {
      question: "KolayYük'te ilan oluşturmak ücretli mi?",
      answer: "Hayır. KolayYük'te yük ilanı oluşturmak tamamen ücretsizdir.",
    },
    {
      question: "Taraflar nasıl iletişime geçiyor?",
      answer:
        "Yük veren bir teklifi kabul ettiğinde, nakliyecinin iletişim bilgilerine erişebilir ve taşıma sürecini birlikte planlayabilir.",
    },
  ];

  return (
    <section
      id="faq"
      className="bg-gray-50 py-24 px-6 md:px-12 border-t border-gray-200"
    >
      <motion.div
        className="max-w-4xl mx-auto text-center mb-12"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <h2 className="text-3xl md:text-4xl font-extrabold text-black">
          Sık Sorulan Sorular
        </h2>
        <p className="text-gray-600 mt-3">
          KolayYük hakkında en merak edilen soruların yanıtlarını burada bulabilirsiniz.
        </p>
      </motion.div>

      <div className="max-w-3xl mx-auto space-y-4">
        {faqs.map((faq, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.6,
              delay: i * 0.1,
              ease: "easeOut",
            }}
            viewport={{ once: true }}
          >
            <Disclosure>
              {({ open }) => (
                <div className="bg-white rounded-xl shadow-sm border-2 border-black transition">
                  <Disclosure.Button className="flex justify-between w-full px-6 py-5 text-left text-gray-900 font-semibold focus:outline-none">
                    <span>{faq.question}</span>
                    <ChevronDown
                      className={`${
                        open ? "rotate-180 text-black" : "text-gray-400"
                      } w-5 h-5 transform transition-transform duration-300`}
                    />
                  </Disclosure.Button>

                  <AnimatePresence initial={false}>
                    {open && (
                      <motion.div
                        key="content"
                        initial={{ opacity: 0, height: 0, y: 6 }}
                        animate={{ opacity: 1, height: "auto", y: 0 }}
                        exit={{ opacity: 0, height: 0, y: 6 }}
                        transition={{
                          duration: 0.25,
                          ease: "easeOut",
                        }}
                      >
                        <div className="px-6 pb-5 text-gray-600 text-sm leading-relaxed border-t border-gray-200">
                          {faq.answer}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              )}
            </Disclosure>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
